export default {
	forms: {
		edit: {
			config: {
				fields: {
					value: {},
					name: {},
					description: {}
				}
			}
		},
		list: {
			config: {
				actions: {
					view: false,
					edit: true,
					create: true,
					copy: false,
					delete: true
				},
				fields: {
					value: {},
					name: {},
					description: {}
				}
			}
		},
		select: {
			panel: {
				height: '500px',
				width: '40%'
			},
			config: {
				fields: {
					value: {},
					name: {}
				}
			}
		}
	}
}